(function () {
  'use strict';

  var STORAGE_PREFIX = 'ns_quote_form_v7_';
  var DISCOUNT_REOPEN_KEY = 'ns_quote_discount_reopen_v7';
  var QUOTE_SCOPED_DISCOUNT_KEY = 'ns_quote_scoped_discount_v7';
  var VALIDATED_DISCOUNT_PREFIX = 'ns_quote_discount_validated_v7_';
  var RFQ_EVENT_PREFIX = 'ns_quote_rfq_event_v7_';
  var RFQ_EMAIL_PREFIX = 'ns_quote_rfq_email_v7_';
  var VAT_RATE = 0.14;
  var VALIDITY_DAYS = 7;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var FALLBACK_ZONES = {
    cairo: {
      labelEn: 'Greater Cairo', labelAr: 'القاهرة الكبرى', charge: 11000, freeThreshold: 5000000,
      governorates: ['6th of October', 'Cairo', 'Giza', 'Helwan', 'Qalyubia']
    },
    delta: {
      labelEn: 'Delta & Canal', labelAr: 'الدلتا والقناة', charge: 15000, freeThreshold: 5000000,
      governorates: ['Al Sharqia', 'Alexandria', 'Beheira', 'Dakahlia', 'Damietta', 'Gharbia', 'Ismailia', 'Kafr el-Sheikh', 'Monufia', 'Port Said', 'Suez']
    },
    upper: {
      labelEn: 'Upper Egypt & Remote', labelAr: 'الصعيد والمناطق النائية', charge: 19000, freeThreshold: 6000000,
      governorates: ['Aswan', 'Asyut', 'Beni Suef', 'Faiyum', 'Luxor', 'Matrouh', 'Minya', 'New Valley', 'North Sinai', 'Qena', 'Red Sea', 'Sohag', 'South Sinai']
    }
  };

  var runtime = {
    data: null,
    shipping: null,
    shippingRequest: 0,
    returnSnapshot: null,
    applyingDiscount: false,
    lastFocus: null,
    originalTitle: document.title,
    currentQuoteNumber: '',
    currentShareUrl: '',
    currentPrintMode: 'english',
    currentPrintFilename: '',
    currentRequest: null,
    filenames: {}
  };

  function qs(selector, root) { return (root || document).querySelector(selector); }
  function qsa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function rootUrl(path) { return ROOT + String(path || '').replace(/^\//, ''); }

  function parseData() {
    var el = qs('#NsQuoteCartData');
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (error) { console.error('Noor quotation data could not be read.', error); return null; }
  }

  function t(data, key, fallback) {
    return data && data.i18n && data.i18n[key] ? data.i18n[key] : fallback;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function decodeEntities(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = String(value == null ? '' : value);
    return textarea.value;
  }

  function cleanText(value) {
    var current = String(value == null ? '' : value);
    for (var i = 0; i < 3; i += 1) {
      var decoded = decodeEntities(current);
      if (decoded === current) break;
      current = decoded;
    }
    return current.trim();
  }

  function normalizeCode(value) { return String(value || '').replace(/\s+/g, '').toUpperCase(); }

  function rememberQuoteDiscount(code) {
    try {
      if (!code) return;
      localStorage.setItem(QUOTE_SCOPED_DISCOUNT_KEY, JSON.stringify({
        code: String(code).trim(),
        savedAt: Date.now()
      }));
    } catch (error) {}
  }

  function readQuoteDiscount() {
    try {
      var stored = JSON.parse(localStorage.getItem(QUOTE_SCOPED_DISCOUNT_KEY) || 'null');
      return stored && stored.code ? String(stored.code).trim() : '';
    } catch (error) {
      return '';
    }
  }

  function forgetQuoteDiscount() {
    try { localStorage.removeItem(QUOTE_SCOPED_DISCOUNT_KEY); }
    catch (error) {}
  }

  function cartDiscountCodeTitles(cart) {
    var titles = [];

    (cart && cart.discount_codes || []).forEach(function (entry) {
      if (!entry || !entry.code || entry.applicable === false) return;
      titles.push(String(entry.code).trim());
    });

    discountCodeTitles(applicationListFromAjax(cart || {})).forEach(function (title) {
      titles.push(String(title || '').trim());
    });

    var seen = {};
    return titles.filter(function (title) {
      var normalized = normalizeCode(title);
      if (!normalized || seen[normalized]) return false;
      seen[normalized] = true;
      return true;
    });
  }

  function removeQuoteDiscountFromNormalCart() {
    var quoteCode = readQuoteDiscount();

    // A quotation link is allowed to keep and restore its own discount.
    if (!quoteCode || parseSnapshot()) return Promise.resolve(false);

    return fetchCart()
      .then(function (cart) {
        var currentCodes = cartDiscountCodeTitles(cart);
        var quoteCodeApplied = currentCodes.some(function (code) {
          return normalizeCode(code) === normalizeCode(quoteCode);
        });

        if (!quoteCodeApplied) {
          forgetQuoteDiscount();
          return false;
        }

        var remainingCodes = currentCodes.filter(function (code) {
          return normalizeCode(code) !== normalizeCode(quoteCode);
        });

        return postDiscount(remainingCodes.join(','))
          .then(function () {
            // Clear the marker before reloading to prevent a cleanup loop.
            forgetQuoteDiscount();
            window.location.reload();
            return true;
          });
      })
      .catch(function () {
        return false;
      });
  }


  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-EG', {
        style: 'currency', currency: currency || 'EGP', minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amount);
    } catch (error) { return amount.toFixed(2) + ' ' + (currency || 'EGP'); }
  }

  function pad(value) { return String(value).padStart(2, '0'); }
  function dateOnly(date) { return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()); }
  function displayDate(date) { return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear(); }

  function makeQuoteNumber(date) {
    var random;
    try {
      var bytes = new Uint8Array(3);
      window.crypto.getRandomValues(bytes);
      random = Array.prototype.map.call(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('').toUpperCase();
    } catch (error) { random = String(Math.floor(Math.random() * 1000000)).padStart(6, '0'); }
    return 'NSS-Q-' + date.getFullYear() + pad(date.getMonth() + 1) + pad(date.getDate()) + '-' + random;
  }

  function safeFilenamePart(value) {
    return cleanText(value || '').replace(/[^a-zA-Z0-9\u0600-\u06FF_-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48) || 'Customer';
  }

  function aggregateApplications(applications) {
    var grouped = {};
    (applications || []).forEach(function (application) {
      var title = String(application.title || '').trim();
      var type = String(application.type || '').toLowerCase();
      if (!title) return;
      var key = type + '|' + title;
      if (!grouped[key]) grouped[key] = { title: title, type: type, amount: 0 };
      grouped[key].amount += Number(application.amount || 0);
    });
    return Object.keys(grouped).map(function (key) { return grouped[key]; });
  }

  function applicationListFromAjax(cart) {
    var list = [];
    var cartLevel = {};
    (cart.cart_level_discount_applications || []).forEach(function (application) {
      var key = String(application.type || '').toLowerCase() + '|' + String(application.title || '').trim();
      cartLevel[key] = true;
      list.push({ title: application.title || '', type: application.type || '', amount: Number(application.total_allocated_amount || 0) });
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var application = allocation.discount_application || {};
        var key = String(application.type || '').toLowerCase() + '|' + String(application.title || '').trim();
        if (cartLevel[key]) return;
        list.push({ title: application.title || '', type: application.type || '', amount: Number(allocation.amount || 0) });
      });
    });
    return aggregateApplications(list);
  }

  function codeApplications(applications) {
    return aggregateApplications(applications).filter(function (application) { return String(application.type || '').toLowerCase() === 'discount_code'; });
  }
  function discountCodeTitles(applications) { return codeApplications(applications).map(function (application) { return application.title; }); }
  function applicationAmount(applications, type) {
    return aggregateApplications(applications).reduce(function (sum, app) { return String(app.type || '').toLowerCase() === type ? sum + Number(app.amount || 0) : sum; }, 0);
  }

  function discountStatus(data) {
    var codes = discountCodeTitles(data.discount_applications || []);
    if (Number(data.special_discount || 0) > 0) return t(data, 'discount_applied', 'Applied discount:') + ' ' + (codes.length ? codes.join(', ') : money(data.special_discount, data.currency));
    return '';
  }

  function storageScope(data) {
    var location = data && data.customer ? data.customer.company_location : '';
    return String((data && data.customer_id) || 'guest') + '_' + String(location || 'default').replace(/[^a-zA-Z0-9_-]+/g, '_');
  }

  function accountFieldValues(data) {
    var customer = data.customer || {};
    return {
      company: cleanText(customer.company || ''), contact: cleanText(customer.name || ''), email: cleanText(customer.email || ''), phone: cleanText(customer.phone || ''),
      tax_registration: cleanText(customer.tax_registration || ''), commercial_registration: cleanText(customer.commercial_registration || ''),
      billing_address: cleanText(customer.billing_address || ''), billing_governorate: cleanText(customer.billing_governorate || ''), billing_city: cleanText(customer.billing_city || ''), billing_zip: cleanText(customer.billing_zip || ''),
      same_as_billing: 'true',
      delivery_address: cleanText(customer.delivery_address || ''), delivery_governorate: cleanText(customer.delivery_governorate || ''), delivery_city: cleanText(customer.delivery_city || ''), delivery_zip: cleanText(customer.delivery_zip || ''),
      payment_terms: cleanText(customer.payment_terms || 'According to approved account terms confirmed at order submission.'), print_language: 'english'
    };
  }

  function accountSignature(data) { return JSON.stringify(accountFieldValues(data)); }

  function isStandardAdvancePaymentTerms(value) {
    var terms = cleanText(value || '').toLowerCase().replace(/\s+/g, ' ');
    if (!terms) return true;

    // Generic fallback copy is not a special approved term and should not
    // occupy space in the quotation popup.
    if (terms === 'according to approved account terms confirmed at order submission.' ||
        terms === 'according to approved account terms.') return true;

    return /100\s*%/.test(terms) &&
      /(advance|advanced|upfront|prepaid|before\s+(order|confirmation|processing|delivery)|مقدم|مقدماً|مقدما|قبل)/i.test(terms);
  }

  function findPaymentTermsContainer(modal, field) {
    var current = field ? field.parentElement : null;

    while (current && current !== modal) {
      var text = cleanText(current.textContent || '');
      var fieldCount = qsa('[data-ns-quote-field]', current).length;
      var hasPaymentCopy = /Approved payment terms/i.test(text) ||
        /These terms are read from the selected company account/i.test(text);

      if (fieldCount === 1 && hasPaymentCopy) return current;
      current = current.parentElement;
    }

    if (!field) return null;
    return field.closest('.field, .ns-quote-field, .ns-quote-form__field, .form__field') || field.parentElement;
  }

  function ensurePopupPresentationStyles() {
    if (qs('#NsQuotePopupPresentationStyles')) return;

    var style = document.createElement('style');
    style.id = 'NsQuotePopupPresentationStyles';
    style.textContent =
      '[data-ns-quote-reset]{border:1px solid currentColor!important;border-radius:6px!important;padding:.65rem .9rem!important;background:transparent!important;text-decoration:none!important;}' +
      '[data-ns-quote-reset]:hover{opacity:.8;}' +
      '.ns-quote-payment-term-compact{margin:.6rem 0 1rem;font-weight:600;line-height:1.45;}' +
      '@media screen and (max-width: 767px){' +
        '[data-ns-quote-print]{overflow-x:hidden!important;padding:0 0 1rem!important;}' +
        '[data-ns-quote-print] [data-ns-quote-close-print],[data-ns-quote-print] [data-ns-quote-print-action]{appearance:none!important;-webkit-appearance:none!important;min-height:32px!important;height:32px!important;padding:0 13px!important;font-family:inherit!important;font-size:11.5px!important;line-height:30px!important;border-radius:4px!important;box-shadow:none!important;outline:none!important;font-weight:650!important;letter-spacing:0!important;transform:none!important;}' +
        '[data-ns-quote-print] [data-ns-quote-close-print]::before,[data-ns-quote-print] [data-ns-quote-close-print]::after,[data-ns-quote-print] [data-ns-quote-print-action]::before,[data-ns-quote-print] [data-ns-quote-print-action]::after{content:none!important;display:none!important;box-shadow:none!important;}' +
        '[data-ns-quote-print] [data-ns-quote-close-print]{background:#f8faf9!important;border:1px solid #d7dfdb!important;color:#26322c!important;min-width:96px!important;}' +
        '[data-ns-quote-print] [data-ns-quote-print-action]{background:#079447!important;border:1px solid #079447!important;color:#fff!important;min-width:116px!important;}' +
        '[data-ns-quote-print] [data-ns-quote-close-print]:hover,[data-ns-quote-print] [data-ns-quote-close-print]:focus{background:#f1f5f3!important;border-color:#c7d1cc!important;box-shadow:none!important;}' +
        '[data-ns-quote-print] [data-ns-quote-print-action]:hover,[data-ns-quote-print] [data-ns-quote-print-action]:focus{background:#078640!important;border-color:#078640!important;box-shadow:none!important;}' +
        '[data-ns-quote-print] .ns-quote-page{width:calc(100vw - 16px)!important;max-width:430px!important;min-height:auto!important;margin:0 auto 16px!important;padding:14px 12px 12px!important;box-sizing:border-box!important;box-shadow:0 4px 14px rgba(0,0,0,.10)!important;border-radius:2px!important;overflow:hidden!important;}' +
        '[data-ns-quote-print] .ns-quote-letterhead{gap:8px!important;align-items:center!important;margin-bottom:8px!important;}' +
        '[data-ns-quote-print] .ns-quote-brand{display:flex!important;align-items:center!important;gap:7px!important;min-width:0!important;}' +
        '[data-ns-quote-print] .ns-quote-brand > div{display:flex!important;flex-direction:column!important;justify-content:center!important;min-width:0!important;}' +
        '[data-ns-quote-print] .ns-quote-brand__logo{width:34px!important;height:auto!important;flex:0 0 34px!important;align-self:center!important;}' +
        '[data-ns-quote-print] .ns-quote-brand h1{font-size:15px!important;line-height:1.05!important;margin:0 0 2px!important;}' +
        '[data-ns-quote-print] .ns-quote-brand p{font-size:8.5px!important;line-height:1.2!important;margin:0!important;}' +
        '[data-ns-quote-print] .ns-quote-letterhead__ref{font-size:8.5px!important;line-height:1.35!important;min-width:0!important;}' +
        '[data-ns-quote-print] .ns-quote-letterhead__ref p{margin:0 0 2px!important;}' +
        '[data-ns-quote-print] .ns-quote-page-title{margin:8px 0 10px!important;padding-top:8px!important;}' +
        '[data-ns-quote-print] .ns-quote-page-title h2{font-size:13px!important;line-height:1.2!important;letter-spacing:.04em!important;}' +
        '[data-ns-quote-print] .ns-quote-customer-box{padding:9px!important;margin-bottom:9px!important;}' +
        '[data-ns-quote-print] .ns-quote-customer-box h3{font-size:10.5px!important;line-height:1.25!important;margin-bottom:6px!important;}' +
        '[data-ns-quote-print] .ns-quote-customer-grid{gap:3px 8px!important;}' +
        '[data-ns-quote-print] .ns-quote-customer-box p,[data-ns-quote-print] .ns-quote-doc-intro,[data-ns-quote-print] .ns-quote-doc-terms,[data-ns-quote-print] .ns-quote-terms-link,[data-ns-quote-print] .ns-quote-doc-return{font-size:9.4px!important;line-height:1.45!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-terms h3{font-size:11px!important;line-height:1.25!important;margin-bottom:5px!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-terms ol{padding-inline-start:18px!important;margin-top:5px!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-terms li{margin-bottom:3px!important;}' +
        '[data-ns-quote-print] .ns-quote-table,[data-ns-quote-print] .ns-quote-bank-table,[data-ns-quote-print] .ns-quote-doc-summary{table-layout:fixed!important;width:100%!important;}' +
        '[data-ns-quote-print] .ns-quote-table{font-size:8.4px!important;line-height:1.25!important;}' +
        '[data-ns-quote-print] .ns-quote-table th,[data-ns-quote-print] .ns-quote-table td{padding:5px 3px!important;word-break:normal!important;overflow-wrap:break-word!important;vertical-align:top!important;}' +
        '[data-ns-quote-print] .ns-quote-table th:nth-child(1),[data-ns-quote-print] .ns-quote-table td:nth-child(1){width:5%!important;text-align:center!important;}' +
        '[data-ns-quote-print] .ns-quote-table th:nth-child(2),[data-ns-quote-print] .ns-quote-table td:nth-child(2){width:45%!important;}' +
        '[data-ns-quote-print] .ns-quote-table th:nth-child(3),[data-ns-quote-print] .ns-quote-table td:nth-child(3){width:8%!important;text-align:center!important;}' +
        '[data-ns-quote-print] .ns-quote-table th:nth-child(4),[data-ns-quote-print] .ns-quote-table td:nth-child(4),[data-ns-quote-print] .ns-quote-table th:nth-child(5),[data-ns-quote-print] .ns-quote-table td:nth-child(5){width:21%!important;text-align:right!important;white-space:nowrap!important;font-variant-numeric:tabular-nums!important;}' +
        '[data-ns-quote-print] .ns-quote-sku{font-size:8.2px!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-summary{font-size:9px!important;line-height:1.3!important;margin-top:10px!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-summary td{padding:5px 4px!important;word-break:normal!important;overflow-wrap:break-word!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-summary td:last-child{white-space:nowrap!important;text-align:right!important;font-variant-numeric:tabular-nums!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-return{margin-top:8px!important;padding:8px 10px!important;border:1px dashed rgba(18,161,80,.35)!important;background:#fbfdfb!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-return p{margin:0!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-return p + p{margin-top:2px!important;}' +
        '[data-ns-quote-print] .ns-quote-doc-return a{display:inline-block!important;font-size:10.4px!important;font-weight:700!important;line-height:1.15!important;}' +
        '[data-ns-quote-print] .ns-quote-document-set--rtl .ns-quote-doc-return{text-align:right!important;}' +
        '[data-ns-quote-print] .ns-quote-bank-table{font-size:9.5px!important;line-height:1.35!important;}' +
        '[data-ns-quote-print] .ns-quote-bank-table th{width:34%!important;padding:7px 6px!important;word-break:normal!important;overflow-wrap:break-word!important;}' +
        '[data-ns-quote-print] .ns-quote-bank-table td{width:66%!important;padding:7px 6px!important;word-break:normal!important;overflow-wrap:anywhere!important;}' +
        '[data-ns-quote-print] .ns-quote-page-footer{position:static!important;left:auto!important;right:auto!important;bottom:auto!important;margin-top:10px!important;padding-top:7px!important;border-top:1px solid rgba(0,0,0,.12)!important;display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;gap:4px 10px!important;font-size:8.2px!important;line-height:1.35!important;color:#4d5a53!important;word-break:normal!important;overflow-wrap:break-word!important;}' +
        '[data-ns-quote-print] .ns-quote-page-footer strong{display:block!important;margin-bottom:1px!important;font-size:8.5px!important;line-height:1.25!important;color:#24322a!important;}' +
        '[data-ns-quote-print] .ns-quote-page-footer > div{min-width:0!important;}' +
        '[data-ns-quote-print] .ns-quote-page-footer > div:last-child{text-align:right!important;}' +
      '}';
    document.head.appendChild(style);
  }

  function applyPopupPresentation(modal, data) {
    if (!modal || !data) return;

    ensurePopupPresentationStyles();

    var paymentField = qs('[data-ns-quote-field="payment_terms"]', modal);
    var paymentContainer = findPaymentTermsContainer(modal, paymentField);
    var existingCompact = qs('[data-ns-quote-payment-term-compact]', modal);
    if (existingCompact) existingCompact.remove();

    if (!paymentField || !paymentContainer) return;

    var terms = cleanText((data.customer && data.customer.payment_terms) || paymentField.value || '');
    var standardAdvance = isStandardAdvancePaymentTerms(terms);

    // Remove the old titled/explanatory block from the popup in all cases.
    paymentContainer.hidden = true;

    // Only non-standard account terms (for example Net 30) remain visible,
    // and they are shown as the payment term itself with no heading or note.
    if (!standardAdvance && terms) {
      var compact = document.createElement('div');
      compact.className = 'ns-quote-payment-term-compact';
      compact.setAttribute('data-ns-quote-payment-term-compact', '');
      compact.textContent = terms;
      paymentContainer.parentNode.insertBefore(compact, paymentContainer);
    }
  }

  function getFields(root) {
    var result = {};
    qsa('[data-ns-quote-field]', root).forEach(function (field) { result[field.getAttribute('data-ns-quote-field')] = (field.value || '').trim(); });
    var same = qs('[data-ns-quote-same-address]', root);
    result.same_as_billing = same && same.checked ? 'true' : 'false';
    return result;
  }

  function setField(root, key, value) {
    var field = qs('[data-ns-quote-field="' + key + '"]', root);
    if (field && value != null) field.value = value;
  }

  function applySameAddressState(modal, checked) {
    var same = qs('[data-ns-quote-same-address]', modal);
    var delivery = qs('[data-ns-quote-delivery-fields]', modal);
    if (same) same.checked = !!checked;
    if (delivery) delivery.hidden = !!checked;
  }

  function loadSavedFields(modal, data, accountOnly) {
    var account = accountFieldValues(data);
    var values = account;
    if (!accountOnly) {
      try {
        var saved = JSON.parse(localStorage.getItem(STORAGE_PREFIX + storageScope(data)) || 'null');
        if (saved && saved.accountSignature === accountSignature(data) && saved.fields) values = Object.assign({}, account, saved.fields);
      } catch (error) {}
    }
    Object.keys(account).forEach(function (key) { if (key !== 'same_as_billing') setField(modal, key, cleanText(values[key] == null ? account[key] : values[key])); });
    applySameAddressState(modal, String(values.same_as_billing) !== 'false');
  }

  function saveFields(modal, data) {
    try {
      localStorage.setItem(STORAGE_PREFIX + storageScope(data), JSON.stringify({ accountSignature: accountSignature(data), fields: getFields(modal) }));
    } catch (error) {}
  }

  function resetAccountFields() {
    var modal = qs('[data-ns-quote-modal]');
    var data = runtime.data || parseData();
    if (!modal || !data) return;
    try { localStorage.removeItem(STORAGE_PREFIX + storageScope(data)); } catch (error) {}
    loadSavedFields(modal, data, true);
    applyPopupPresentation(modal, data);
    runtime.shipping = null;
    renderSummary(modal, data);
    requestShipping(modal, data);
  }

  function effectiveDelivery(fields) {
    if (String(fields.same_as_billing) !== 'false') {
      return { address: fields.billing_address, governorate: fields.billing_governorate, city: fields.billing_city, zip: fields.billing_zip };
    }
    return { address: fields.delivery_address, governorate: fields.delivery_governorate, city: fields.delivery_city, zip: fields.delivery_zip };
  }

  function formatAddress(address, city, governorate, zip) {
    return [cleanText(address), cleanText(city), cleanText(governorate), cleanText(zip)].filter(Boolean).join(', ');
  }

  function renderFacility(modal, data) {
    var panel = qs('[data-ns-quote-facility]', modal);
    if (!panel) return;
    var credit = data.credit || {};
    if (!credit.deferred_allowed) { panel.hidden = true; return; }
    panel.hidden = false;
    function egpCents(value) { var n = Number(value); return value === '' || value == null || !Number.isFinite(n) ? null : Math.round(n * 100); }
    var limit = egpCents(credit.approved_limit_egp);
    var available = egpCents(credit.available_egp);
    var status = qs('[data-ns-credit-status]', panel);
    if (status) {
      var statusText = credit.status || t(data, 'facility_active', 'Active');
      status.textContent = statusText;
      status.className = 'ns-quote-facility__status' + (/block|inactive|overdue|suspend|hold|وقف|متأخر|غير نشط/i.test(statusText) ? ' ns-quote-facility__status--warning' : ' ns-quote-facility__status--active');
    }
    var el = qs('[data-ns-credit-limit]', panel); if (el) el.textContent = limit == null ? '—' : money(limit, data.currency);
    el = qs('[data-ns-credit-available]', panel); if (el) el.textContent = available == null ? '—' : money(available, data.currency);
    el = qs('[data-ns-credit-terms]', panel); if (el) el.textContent = (data.customer && data.customer.payment_terms) || '—';
    el = qs('[data-ns-credit-updated]', panel); if (el) { el.textContent = credit.last_updated ? t(data, 'facility_updated', 'Last updated:') + ' ' + credit.last_updated : ''; el.hidden = !credit.last_updated; }
  }

  function calculateTotals(data) {
    var shipping = runtime.shipping ? Number(runtime.shipping.price || 0) : 0;
    var netProducts = Number(data.net_products || 0);
    var vat = Math.round((netProducts + shipping) * VAT_RATE);
    return { shipping: shipping, vat: vat, grandTotal: netProducts + shipping + vat, totalDiscount: Number(data.basic_discount || 0) + Number(data.special_discount || 0) };
  }

  function renderSummary(modal, data) {
    var host = qs('[data-ns-quote-summary]', modal);
    if (!host) return;
    var totals = calculateTotals(data);
    var zone = runtime.shipping ? cleanText(runtime.shipping.name || '') : '—';
    var rows = [
      [t(data, 'catalogue_value', 'Total value'), money(data.catalogue_total, data.currency)],
      [t(data, 'basic_product_discount', 'Basic product discount'), '−' + money(data.basic_discount, data.currency)],
      [t(data, 'special_coupon_discount', 'Special coupon discount'), '−' + money(data.special_discount, data.currency)],
      [t(data, 'net_products', 'Value after discount'), money(data.net_products, data.currency)],
      [t(data, 'shipping_cost', 'Shipping Cost') + '<small>' + t(data, 'delivery_zone', 'Delivery zone') + ': ' + escapeHtml(zone) + '</small>', runtime.shipping ? money(totals.shipping, data.currency) : '—'],
      [t(data, 'vat_products_shipping', 'VAT 14% on products and shipping'), runtime.shipping ? money(totals.vat, data.currency) : '—'],
      [t(data, 'quotation_total', 'Total quotation value'), runtime.shipping ? money(totals.grandTotal, data.currency) : '—', 'total']
    ];
    host.innerHTML = rows.map(function (row) { return '<div class="ns-quote-summary__row' + (row[2] ? ' ns-quote-summary__row--' + row[2] : '') + '"><span>' + row[0] + '</span><strong>' + row[1] + '</strong></div>'; }).join('');
    var status = qs('[data-ns-quote-discount-status]');
    if (status && !status.dataset.messageLock) {
      var discountText = discountStatus(data);
      status.textContent = discountText;
      status.hidden = !discountText;
    }
  }

  function findFallbackZone(governorate) {
    var keys = Object.keys(FALLBACK_ZONES);
    for (var i = 0; i < keys.length; i += 1) {
      var zone = FALLBACK_ZONES[keys[i]];
      if (zone.governorates.indexOf(governorate) !== -1) return { key: keys[i], labelEn: zone.labelEn, labelAr: zone.labelAr, charge: zone.charge, freeThreshold: zone.freeThreshold };
    }
    return null;
  }

  function fallbackShipping(data, governorate) {
    var zone = findFallbackZone(governorate);
    if (!zone) return null;
    return { price: Number(data.net_products || 0) >= zone.freeThreshold ? 0 : zone.charge, name: zone.labelEn, nameAr: zone.labelAr, source: 'fallback' };
  }

  function updateShippingStatus(data, text, type) {
    var status = qs('[data-ns-quote-shipping-status]');
    if (!status) return;
    status.className = 'ns-quote-shipping-status' + (type ? ' ns-quote-shipping-status--' + type : '');
    status.textContent = text || '';
    status.hidden = !text;
  }

  function buildShippingQuery(delivery) {
    var params = new URLSearchParams();
    params.set('shipping_address[country]', 'Egypt');
    params.set('shipping_address[province]', delivery.governorate || '');
    if (delivery.city) params.set('shipping_address[city]', delivery.city);
    if (delivery.zip) params.set('shipping_address[zip]', delivery.zip);
    return params.toString();
  }

  function selectShippingRate(response) {
    var rates = response && Array.isArray(response.shipping_rates) ? response.shipping_rates : [];
    if (!rates.length) return null;
    rates.sort(function (a, b) { return parseFloat(a.price || 0) - parseFloat(b.price || 0); });
    var rate = rates[0];
    return { price: Math.round(parseFloat(rate.price || 0) * 100), name: rate.name || rate.code || 'Shipping', nameAr: 'الشحن', source: 'shopify' };
  }

  function requestShipping(modal, data) {
    var delivery = effectiveDelivery(getFields(modal));
    if (!delivery.governorate) { runtime.shipping = null; updateShippingStatus(data, '', ''); renderSummary(modal, data); return Promise.resolve(null); }
    var requestId = ++runtime.shippingRequest;
    runtime.shipping = null;
    updateShippingStatus(data, t(data, 'shipping_calculating', 'Calculating the current Shopify shipping rate…'), 'loading');
    renderSummary(modal, data);
    return fetch(rootUrl('cart/shipping_rates.json') + '?' + buildShippingQuery(delivery), { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { if (!response.ok) throw new Error('shipping'); return response.json(); })
      .then(function (response) {
        if (requestId !== runtime.shippingRequest) return null;
        var rate = selectShippingRate(response); if (!rate) throw new Error('no-rate');
        runtime.shipping = rate;
        updateShippingStatus(data, t(data, 'shipping_cost', 'Shipping Cost') + ': ' + money(rate.price, data.currency) + ' · ' + t(data, 'delivery_zone', 'Delivery zone') + ': ' + rate.name, 'success');
        renderSummary(modal, data); return rate;
      })
      .catch(function () {
        if (requestId !== runtime.shippingRequest) return null;
        var fallback = fallbackShipping(data, delivery.governorate);
        runtime.shipping = fallback;
        if (fallback) updateShippingStatus(data, t(data, 'shipping_fallback', 'The configured zone rate is shown and will be rechecked at checkout.') + ' ' + money(fallback.price, data.currency), 'warning');
        else updateShippingStatus(data, t(data, 'shipping_unavailable', 'A shipping rate could not be calculated for this address. Review the address and try again.'), 'error');
        renderSummary(modal, data); return fallback;
      });
  }

  function mergeLiveCart(data, live) {
    var baseByVariant = {};
    (data.items || []).forEach(function (item) { baseByVariant[String(item.variant_id)] = item; });
    data.items = (live.items || []).map(function (item) {
      var base = baseByVariant[String(item.variant_id)] || {};
      var reference = Number(base.reference_unit_price || item.original_price || item.price || 0);
      var selling = Number(item.original_price || item.price || base.selling_unit_price || 0);
      return {
        variant_id: item.variant_id, title: item.product_title || item.title || base.title || '', variant_title: item.variant_title || base.variant_title || '', sku: item.sku || base.sku || '', quantity: Number(item.quantity || 0),
        reference_unit_price: reference, selling_unit_price: selling, selling_line_price: Number(item.original_line_price || selling * item.quantity), final_line_price: Number(item.final_line_price || item.line_price || selling * item.quantity),
        available: base.available !== false, can_quote: base.can_quote !== false, inventory_management: base.inventory_management || '', inventory_policy: base.inventory_policy || '', inventory_quantity: Number(base.inventory_quantity == null ? -1 : base.inventory_quantity)
      };
    });
    data.catalogue_total = data.items.reduce(function (sum, item) { return sum + Number(item.reference_unit_price || 0) * Number(item.quantity || 0); }, 0);
    data.basic_discount = data.items.reduce(function (sum, item) { return sum + Math.max(0, Number(item.reference_unit_price || 0) - Number(item.selling_unit_price || 0)) * Number(item.quantity || 0); }, 0);
    data.selling_subtotal = Number(live.original_total_price || 0);
    data.discount_applications = applicationListFromAjax(live);
    data.special_discount = applicationAmount(data.discount_applications, 'discount_code');
    data.other_discount = Math.max(0, Number(live.total_discount || 0) - Number(data.special_discount || 0));
    data.net_products = Number(live.total_price || 0);
    return data;
  }

  function fetchCart() { return fetch(rootUrl('cart.js'), { headers: { Accept: 'application/json' } }).then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); }); }
  function refreshData(data) { return fetchCart().then(function (live) { return mergeLiveCart(data, live); }).catch(function () { return data; }); }

  function mountOverlays() {
    var modal = qs('[data-ns-quote-modal]'); var printEl = qs('[data-ns-quote-print]');
    if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
    if (printEl && printEl.parentNode !== document.body) document.body.appendChild(printEl);
  }

  function openModal() {
    var modal = qs('[data-ns-quote-modal]'); var data = parseData();
    if (!modal || !data) return;
    runtime.lastFocus = document.activeElement;
    refreshData(data).then(function (fresh) {
      runtime.data = fresh; loadSavedFields(modal, fresh); applyPopupPresentation(modal, fresh); renderFacility(modal, fresh); modal.hidden = false; document.body.classList.add('ns-quote-open');
      renderSummary(modal, fresh); requestShipping(modal, fresh);
      var first = qs('input:not([readonly]), select, textarea, button', modal); if (first) first.focus({ preventScroll: true });
    });
  }

  function closeModal() {
    var modal = qs('[data-ns-quote-modal]'); if (modal) modal.hidden = true;
    document.body.classList.remove('ns-quote-open');
    if (runtime.lastFocus && typeof runtime.lastFocus.focus === 'function') { try { runtime.lastFocus.focus({ preventScroll: true }); } catch (error) { runtime.lastFocus.focus(); } }
  }

  function setDiscountMessage(message, type) {
    var status = qs('[data-ns-quote-discount-status]'); if (!status) return;
    status.dataset.messageLock = message ? '1' : '';
    status.className = 'ns-quote-current-discounts' + (type ? ' ns-quote-current-discounts--' + type : '');
    status.textContent = message || '';
    status.hidden = !message;
  }

  function postDiscount(code) {
    return fetch(rootUrl('cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function (response) { if (!response.ok) throw new Error('discount'); return response.json(); });
  }

  function codeIsApplied(cart, code) {
    var normalized = normalizeCode(code);
    if ((cart.discount_codes || []).some(function (entry) { return normalizeCode(entry.code) === normalized && entry.applicable !== false; })) return true;
    return codeApplications(applicationListFromAjax(cart)).some(function (application) { return normalizeCode(application.title) === normalized; });
  }

  function discountValidationKey(snapshot) { return snapshot && snapshot.q ? VALIDATED_DISCOUNT_PREFIX + String(snapshot.q) : ''; }
  function markReturnDiscountValidated() { var key = discountValidationKey(runtime.returnSnapshot); if (key) try { sessionStorage.setItem(key, '1'); } catch (error) {} }
  function returnDiscountWasValidated(snapshot) { var key = discountValidationKey(snapshot); if (!key) return false; try { return sessionStorage.getItem(key) === '1'; } catch (error) { return false; } }

  function applyDiscountCode() {
    if (runtime.applyingDiscount) return;

    var input = qs('#NsQuoteDiscountCode');
    var code = input ? input.value.trim() : '';
    var data = runtime.data || parseData();
    var modal = qs('[data-ns-quote-modal]');

    if (!input || !data) return;

    if (!code) {
      input.focus();
      return;
    }

    // Preserve all quotation fields before the page reloads.
    if (modal) saveFields(modal, data);

    runtime.applyingDiscount = true;

    var button = qs('[data-ns-quote-apply-code]');
    if (button) button.disabled = true;

    setDiscountMessage(
      t(data, 'discount_checking', 'Checking discount code…'),
      'loading'
    );

    fetchCart()
      .then(function (before) {
        var previous = cartDiscountCodeTitles(before);

        return postDiscount(code).then(function (after) {
          if (
            codeIsApplied(after, code) &&
            Number(after.total_discount || 0) > 0
          ) {
            // Mark this code as quotation-scoped. A normal cart load will
            // remove it, while a valid quotation link can restore it.
            rememberQuoteDiscount(code);
            markReturnDiscountValidated();

            try {
              sessionStorage.setItem(DISCOUNT_REOPEN_KEY, '1');
            } catch (error) {}

            window.location.reload();
            return null;
          }

          return postDiscount(previous.join(','))
            .catch(function () {
              return before;
            })
            .then(function () {
              setDiscountMessage(
                t(
                  data,
                  'discount_invalid',
                  'This discount code is invalid or is not applicable to the current cart.'
                ),
                'error'
              );

              input.setAttribute('aria-invalid', 'true');
              input.focus();
              return null;
            });
        });
      })
      .catch(function () {
        setDiscountMessage(
          t(
            data,
            'discount_error',
            'The discount could not be checked. Please try again.'
          ),
          'error'
        );
      })
      .finally(function () {
        runtime.applyingDiscount = false;
        if (button) button.disabled = false;
      });
  }

  function removeDiscountCode() {
    if (runtime.applyingDiscount) return;

    var data = runtime.data || parseData();
    var modal = qs('[data-ns-quote-modal]');

    // Preserve all quotation fields before the page reloads.
    if (modal && data) saveFields(modal, data);

    runtime.applyingDiscount = true;

    postDiscount('')
      .then(function () {
        forgetQuoteDiscount();

        try {
          sessionStorage.setItem(DISCOUNT_REOPEN_KEY, '1');
        } catch (error) {}

        window.location.reload();
      })
      .catch(function () {
        setDiscountMessage(
          t(
            data,
            'discount_error',
            'The discount could not be updated. Please try again.'
          ),
          'error'
        );
      })
      .finally(function () {
        runtime.applyingDiscount = false;
      });
  }

  function stockProblems(data) {
    return (data.items || []).filter(function (item) {
      if (item.can_quote === false || item.available === false) return true;
      return item.inventory_management && item.inventory_policy === 'deny' && item.inventory_quantity >= 0 && item.quantity > item.inventory_quantity;
    });
  }

  function validateModal(modal, data) {
    var required = qsa('[required]', modal).filter(function (field) { return !field.closest('[hidden]'); });
    for (var i = 0; i < required.length; i += 1) {
      if (!required[i].checkValidity()) { required[i].focus(); required[i].reportValidity(); return false; }
    }
    var fields = getFields(modal); var delivery = effectiveDelivery(fields);
    if (!delivery.address || !delivery.governorate || !delivery.city) {
      var target = String(fields.same_as_billing) === 'false' ? qs('[data-ns-quote-field="delivery_address"]', modal) : qs('[data-ns-quote-field="billing_address"]', modal);
      if (target) { target.focus(); target.setCustomValidity('Complete the address, governorate and city.'); target.reportValidity(); setTimeout(function () { target.setCustomValidity(''); }, 0); }
      return false;
    }
    var warning = qs('[data-ns-quote-cart-warning]', modal); var problems = stockProblems(data);
    if (problems.length) {
      if (warning) { warning.hidden = false; warning.textContent = t(data, 'quantity_warning', 'The requested quantity is no longer available for:') + ' ' + problems.map(function (item) { return item.title; }).join(', ') + '. ' + t(data, 'unavailable_warning', 'Update the cart before printing.'); }
      return false;
    }
    if (warning) warning.hidden = true;
    if (Number(data.other_discount || 0) > 0) { if (warning) { warning.hidden = false; warning.textContent = t(data, 'unsupported_discount', 'This cart contains an unsupported additional discount.'); } return false; }
    var input = qs('#NsQuoteDiscountCode', modal);
    if (input && input.value.trim()) {
      var applied = discountCodeTitles(data.discount_applications || []).map(normalizeCode);
      if (input.getAttribute('aria-invalid') === 'true' || applied.indexOf(normalizeCode(input.value)) === -1) {
        setDiscountMessage(t(data, 'discount_not_applied', 'Apply the discount code successfully or clear the field before printing.'), 'error'); input.setAttribute('aria-invalid', 'true'); input.focus(); return false;
      }
    }
    return true;
  }

  function utf8ToBase64Url(value) {
    var bytes = new TextEncoder().encode(value); var binary = '';
    bytes.forEach(function (byte) { binary += String.fromCharCode(byte); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }
  function base64UrlToUtf8(value) {
    var base64 = value.replace(/-/g, '+').replace(/_/g, '/'); while (base64.length % 4) base64 += '=';
    var binary = atob(base64); var bytes = new Uint8Array(binary.length); for (var i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return new TextDecoder().decode(bytes);
  }

  function snapshotForQuote(data, quoteNumber, issued, expires, totals) {
    var codes = discountCodeTitles(data.discount_applications || []);

    return {
      v: 1,
      q: quoteNumber,
      i: dateOnly(issued),
      e: dateOnly(expires),
      c: String(data.customer_id || ''),
      l: (data.items || []).map(function (item) {
        return [
          Number(item.variant_id),
          Number(item.quantity),
          Number(item.selling_unit_price),
          Number(item.reference_unit_price)
        ];
      }),
      d: Number(data.special_discount || 0),
      dc: codes.length ? codes[0] : '',
      s: Number(totals.shipping || 0),
      g: Number(totals.grandTotal || 0)
    };
  }
  function buildReturnUrl(data, snapshot) { var separator = data.quote_cart_url.indexOf('?') === -1 ? '?' : '&'; return data.quote_cart_url + separator + 'nsq=' + encodeURIComponent(utf8ToBase64Url(JSON.stringify(snapshot))); }
  function parseSnapshot() {
    var encoded = new URLSearchParams(window.location.search).get('nsq'); if (!encoded) return null;
    try { var value = JSON.parse(base64UrlToUtf8(encoded)); return value && value.v === 1 ? value : null; } catch (error) { return null; }
  }

  function textFor(mode, en, ar) { return mode === 'arabic' ? ar : en; }

  function pageHeader(mode, data, quoteNumber, issued, expires) {
    var tr = function (en, ar) { return textFor(mode, en, ar); };
    var seller = data.seller || {}; var logo = data.logo_url ? '<img class="ns-quote-brand__logo" src="' + escapeHtml(data.logo_url) + '" alt="Noor Scientific & Trade">' : '';
    return '<header class="ns-quote-letterhead"><div class="ns-quote-brand">' + logo + '<div><h1>' + escapeHtml(cleanText(seller.legal_name || 'Noor Scientific & Trade LLC')) + '</h1><p>Tree of Unwavering Success</p></div></div>' +
      '<div class="ns-quote-letterhead__ref"><p><strong>' + tr('Ref.', 'المرجع') + '</strong> ' + escapeHtml(quoteNumber) + '</p><p><strong>' + tr('Date', 'التاريخ') + '</strong> ' + escapeHtml(displayDate(issued)) + '</p><p><strong>' + tr('Valid until', 'صالح حتى') + '</strong> ' + escapeHtml(displayDate(expires)) + '</p></div></header>';
  }

  function pageFooter(mode, data) {
    var tr = function (en, ar) { return textFor(mode, en, ar); }; var seller = data.seller || {};
    return '<footer class="ns-quote-page-footer"><div><strong>' + escapeHtml(cleanText(seller.legal_name || 'Noor Scientific & Trade LLC')) + '</strong>' + escapeHtml(cleanText(data.shop_address || '')) + '</div><div>' + tr('Tax Registration No.', 'رقم التسجيل الضريبي') + ': ' + escapeHtml(cleanText(seller.tax_registration || '769-530-699')) + '<br>' + tr('Commercial Registration No.', 'رقم السجل التجاري') + ': ' + escapeHtml(cleanText(seller.commercial_registration || '263083')) + '<br>' + escapeHtml(cleanText(data.shop_email || '')) + '</div></footer>';
  }

  function buildLanguageDocument(mode, data, fields, totals, issued, expires, quoteNumber, returnUrl) {
    var isArabic = mode === 'arabic'; var tr = function (en, ar) { return textFor(mode, en, ar); }; var bank = data.bank || {};
    var delivery = effectiveDelivery(fields);
    var billingText = formatAddress(fields.billing_address, fields.billing_city, fields.billing_governorate, fields.billing_zip);
    var deliveryText = formatAddress(delivery.address, delivery.city, delivery.governorate, delivery.zip);
    var paymentTerms = isArabic ? cleanText((data.customer && data.customer.payment_terms_ar) || 'وفقاً لشروط الدفع المعتمدة لحساب الشركة.') : cleanText(fields.payment_terms || 'According to approved account terms.');
    var shippingZone = isArabic ? ((runtime.shipping && runtime.shipping.nameAr) || '—') : ((runtime.shipping && runtime.shipping.name) || '—');
    var direction = isArabic ? ' dir="rtl" lang="ar"' : ' lang="en"'; var setClass = 'ns-quote-document-set' + (isArabic ? ' ns-quote-document-set--rtl' : '');

    var rows = (data.items || []).map(function (item, index) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<br><small>' + escapeHtml(cleanText(item.variant_title)) + '</small>' : '';
      var sku = item.sku ? '<strong class="ns-quote-sku">' + escapeHtml(cleanText(item.sku)) + '</strong><br>' : '';
      return '<tr><td>' + (index + 1) + '</td><td>' + sku + '<strong>' + escapeHtml(cleanText(item.title)) + '</strong>' + variant + '</td><td>' + escapeHtml(item.quantity) + '</td><td>' + escapeHtml(money(item.selling_unit_price, data.currency)) + '</td><td>' + escapeHtml(money(item.selling_line_price, data.currency)) + '</td></tr>';
    }).join('');

    var termsUrl = data.terms_url || '/policies/terms-of-service';
    var html = '<section class="' + setClass + '" data-language="' + mode + '"' + direction + '>';

    html += '<article class="ns-quote-page ns-quote-page--terms">' + pageHeader(mode, data, quoteNumber, issued, expires);
    html += '<div class="ns-quote-page-title"><h2>' + tr('OFFICIAL QUOTATION', 'عرض سعر رسمي') + '</h2></div>';
    html += '<section class="ns-quote-customer-box"><h3>' + tr('Customer Details', 'بيانات العميل') + '</h3>';
    html += '<div class="ns-quote-customer-grid"><p><strong>' + tr('Company', 'الشركة') + ':</strong> ' + escapeHtml(cleanText(fields.company)) + '</p><p><strong>' + tr('Contact', 'مسؤول التواصل') + ':</strong> ' + escapeHtml(cleanText(fields.contact)) + '</p><p><strong>' + tr('Email', 'البريد الإلكتروني') + ':</strong> ' + escapeHtml(cleanText(fields.email)) + '</p><p><strong>' + tr('Phone', 'الهاتف') + ':</strong> ' + escapeHtml(cleanText(fields.phone)) + '</p><p><strong>' + tr('Tax Registration', 'التسجيل الضريبي') + ':</strong> ' + escapeHtml(cleanText(fields.tax_registration || '—')) + '</p><p><strong>' + tr('Commercial Registration', 'السجل التجاري') + ':</strong> ' + escapeHtml(cleanText(fields.commercial_registration || '—')) + '</p></div>';
    html += '<p><strong>' + tr('Billing Address', 'عنوان الفوترة') + ':</strong> ' + escapeHtml(billingText) + '</p><p><strong>' + tr('Delivery Address', 'عنوان التسليم') + ':</strong> ' + escapeHtml(deliveryText) + '</p></section>';
    html += '<p class="ns-quote-doc-intro">' + tr('We are pleased to submit our quotation for the products listed on the following page, according to the commercial terms below.', 'يسرنا أن نتقدم لسيادتكم بعرض السعر للمنتجات الموضحة بالصفحة التالية وفقاً للشروط التجارية أدناه.') + '</p>';
    html += '<section class="ns-quote-doc-terms"><h3>' + tr('Commercial Terms', 'الشروط التجارية') + '</h3><ol>';
    html += '<li><strong>' + tr('Prices', 'الأسعار') + ':</strong> ' + tr('Egyptian pounds, excluding VAT.', 'بالجنيه المصري وغير شاملة ضريبة القيمة المضافة.') + '</li>';
    html += '<li><strong>' + tr('Validity', 'صلاحية العرض') + ':</strong> ' + tr('Seven calendar days from the issue date and not automatically renewable.', 'سبعة أيام تقويمية من تاريخ الإصدار ولا يجدد تلقائياً.') + '</li>';
    html += '<li><strong>' + tr('Availability', 'التوافر') + ':</strong> ' + tr('This quotation covers in-stock items only and does not reserve quantities.', 'يشمل هذا العرض الأصناف المتاحة بالمخزون فقط ولا يحجز الكميات.') + '</li>';
    html += '<li><strong>' + tr('Delivery', 'التوريد') + ':</strong> ' + tr('Within 3–5 business days after payment.', 'خلال 3–5 أيام عمل من الدفع.') + '</li>';
    html += '<li><strong>' + tr('Payment', 'الدفع') + ':</strong> ' + escapeHtml(paymentTerms) + '</li>';
    html += '<li><strong>' + tr('Shipping', 'الشحن') + ':</strong> ' + tr('The shipping cost shown in this quotation is based on the delivery address and is rechecked at checkout.', 'تم احتساب مصاريف الشحن الموضحة في هذا العرض بناءً على عنوان التسليم، ويتم إعادة التحقق منها عند إتمام الطلب.') + '</li>';
    html += '</ol></section>';
    html += '<p class="ns-quote-terms-link"><a href="' + escapeHtml(termsUrl) + '">' + tr('Terms & Conditions', 'الشروط والأحكام') + '</a></p>';
    html += pageFooter(mode, data) + '</article>';

    html += '<article class="ns-quote-page ns-quote-page--products">' + pageHeader(mode, data, quoteNumber, issued, expires);
    html += '<div class="ns-quote-page-title"><h2>' + tr('QUOTATION', 'عرض السعر') + '</h2></div>';
    html += '<table class="ns-quote-table"><thead><tr><th class="ns-quote-col-item">' + tr('Item', 'م') + '</th><th>' + tr('Description / Catalogue No.', 'الوصف / كود الصنف') + '</th><th class="ns-quote-col-qty">' + tr('Qty', 'الكمية') + '</th><th class="ns-quote-col-price">' + tr('Unit Price', 'سعر الوحدة') + '</th><th class="ns-quote-col-total">' + tr('Total Price', 'السعر الإجمالي') + '</th></tr></thead><tbody>' + rows + '</tbody></table>';
    html += '<table class="ns-quote-doc-summary"><tr><td>' + tr('Total value', 'القيمة الأصلية للمنتجات') + '</td><td>' + escapeHtml(money(data.catalogue_total, data.currency)) + '</td></tr><tr><td>' + tr('Basic product discount', 'خصم المنتج الأساسي') + '</td><td>−' + escapeHtml(money(data.basic_discount, data.currency)) + '</td></tr><tr><td>' + tr('Special coupon discount', 'خصم الكوبون الخاص') + '</td><td>−' + escapeHtml(money(data.special_discount, data.currency)) + '</td></tr><tr><td>' + tr('Total discounts', 'إجمالي الخصومات') + '</td><td>−' + escapeHtml(money(totals.totalDiscount, data.currency)) + '</td></tr><tr><td>' + tr('Value after discount', 'صافي المنتجات') + '</td><td>' + escapeHtml(money(data.net_products, data.currency)) + '</td></tr><tr><td>' + tr('Shipping Cost', 'مصاريف الشحن') + '<small>' + tr('Delivery zone', 'منطقة التوصيل') + ': ' + escapeHtml(shippingZone) + '</small></td><td>' + escapeHtml(money(totals.shipping, data.currency)) + '</td></tr><tr><td>' + tr('VAT 14% on products and shipping', 'ضريبة القيمة المضافة 14٪ على المنتجات والشحن') + '</td><td>' + escapeHtml(money(totals.vat, data.currency)) + '</td></tr><tr class="ns-quote-grand-total"><td>' + tr('Total quotation value', 'إجمالي عرض السعر') + '</td><td>' + escapeHtml(money(totals.grandTotal, data.currency)) + '</td></tr></table>';
    html += '<section class="ns-quote-doc-return"><p><a href="' + escapeHtml(returnUrl) + '">' + tr('Review quotation online', 'مراجعة عرض السعر عبر الإنترنت') + '</a></p><p>' + tr('Prices, stock & discounts rechecked before ordering.', 'يُعاد التحقق من الأسعار والمخزون والخصومات قبل الطلب.') + '</p></section>';
    html += pageFooter(mode, data) + '</article>';

    html += '<article class="ns-quote-page ns-quote-page--bank">' + pageHeader(mode, data, quoteNumber, issued, expires);
    html += '<div class="ns-quote-page-title"><h2>' + tr('BANK DETAILS', 'بيانات الحساب البنكي') + '</h2></div>';
    html += '<table class="ns-quote-bank-table"><tr><th>' + tr('Company name', 'اسم الشركة') + '</th><td>' + escapeHtml(cleanText(bank.company_name || '')) + '</td></tr><tr><th>' + tr('Account number', 'رقم الحساب') + '</th><td>' + escapeHtml(cleanText(bank.account_number || '')) + '</td></tr><tr><th>' + tr('Bank name', 'اسم البنك') + '</th><td>' + escapeHtml(cleanText(bank.bank_name || '')) + '</td></tr><tr><th>' + tr('SWIFT code', 'كود السويفت') + '</th><td>' + escapeHtml(cleanText(bank.swift_code || '')) + '</td></tr><tr><th>' + tr('Branch number', 'رقم الفرع') + '</th><td>' + escapeHtml(cleanText(bank.branch_number || '')) + '</td></tr><tr><th>IBAN</th><td>' + escapeHtml(cleanText(bank.iban || '')) + '</td></tr><tr><th>' + tr('Bank address', 'عنوان البنك') + '</th><td>' + escapeHtml(cleanText(bank.address || '')) + '</td></tr></table>';
    html += pageFooter(mode, data) + '</article>';
    html += '</section>';
    return html;
  }

  function printModeSuffix(mode) {
    if (mode === 'arabic') return 'AR';
    if (mode === 'bilingual') return 'Bilingual';
    return 'EN';
  }

  function buildRfqRequest(data, fields, totals, issued, expires, quoteNumber, returnUrl, mode) {
    var delivery = effectiveDelivery(fields);
    var items = (data.items || []).map(function (item) {
      return {
        variant_id: Number(item.variant_id || 0),
        sku: cleanText(item.sku || ''),
        title: cleanText(item.title || ''),
        variant_title: cleanText(item.variant_title || ''),
        quantity: Number(item.quantity || 0),
        unit_price: Number(item.selling_unit_price || 0),
        line_total: Number(item.selling_line_price || 0)
      };
    });

    return {
      quote_number: quoteNumber,
      issued_date: dateOnly(issued),
      valid_until: dateOnly(expires),
      language: mode,
      currency: data.currency || 'EGP',
      customer_id: String(data.customer_id || ''),
      company_location: cleanText(data.customer && data.customer.company_location || ''),
      company: cleanText(fields.company || ''),
      contact: cleanText(fields.contact || ''),
      email: cleanText(fields.email || ''),
      phone: cleanText(fields.phone || ''),
      tax_registration: cleanText(fields.tax_registration || ''),
      commercial_registration: cleanText(fields.commercial_registration || ''),
      billing_address: formatAddress(fields.billing_address, fields.billing_city, fields.billing_governorate, fields.billing_zip),
      delivery_address: formatAddress(delivery.address, delivery.city, delivery.governorate, delivery.zip),
      payment_terms: cleanText(fields.payment_terms || ''),
      catalogue_total: Number(data.catalogue_total || 0),
      basic_discount: Number(data.basic_discount || 0),
      special_discount: Number(data.special_discount || 0),
      net_products: Number(data.net_products || 0),
      shipping: Number(totals.shipping || 0),
      vat: Number(totals.vat || 0),
      grand_total: Number(totals.grandTotal || 0),
      return_url: returnUrl,
      items: items
    };
  }

  function rfqAnalyticsPayload(request) {
    return {
      quote_number: request.quote_number,
      currency: request.currency,
      value: Number(request.grand_total || 0) / 100,
      products_value: Number(request.net_products || 0) / 100,
      shipping_value: Number(request.shipping || 0) / 100,
      vat_value: Number(request.vat || 0) / 100,
      special_discount_value: Number(request.special_discount || 0) / 100,
      language: request.language,
      item_count: request.items.length,
      total_quantity: request.items.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0)
    };
  }

  function publishRfqEvent(request) {
    var key = RFQ_EVENT_PREFIX + request.quote_number;
    try {
      if (sessionStorage.getItem(key) === '1') return;
      sessionStorage.setItem(key, '1');
    } catch (error) {}

    var payload = rfqAnalyticsPayload(request);
    var publishedToShopify = false;

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('noor_store:rfq_submitted', payload);
        publishedToShopify = true;
      }
    } catch (error) { console.warn('Noor RFQ analytics event could not be published.', error); }

    try {
      window.dispatchEvent(new CustomEvent('noor_store:rfq_submitted', { detail: payload }));
    } catch (error) {}

    // Fallback for stores where Shopify's customer-events publisher is unavailable.
    try {
      if (!publishedToShopify && Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'rfq_submitted' }, payload));
      }
    } catch (error) {}
  }

  function quoteEmailBody(request) {
    var lines = [
      'NEW RFQ / PRINTED QUOTATION',
      '',
      'Quotation number: ' + request.quote_number,
      'Issue date: ' + request.issued_date,
      'Valid until: ' + request.valid_until,
      'Selected language: ' + request.language,
      '',
      'CUSTOMER',
      'Company: ' + request.company,
      'Company location: ' + (request.company_location || '—'),
      'Contact: ' + request.contact,
      'Email: ' + request.email,
      'Phone: ' + request.phone,
      'Tax registration: ' + (request.tax_registration || '—'),
      'Commercial registration: ' + (request.commercial_registration || '—'),
      'Billing address: ' + request.billing_address,
      'Delivery address: ' + request.delivery_address,
      'Payment terms: ' + request.payment_terms,
      '',
      'PRODUCTS'
    ];

    request.items.forEach(function (item, index) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? ' | ' + item.variant_title : '';
      lines.push(
        String(index + 1) + '. ' +
        (item.sku ? '[' + item.sku + '] ' : '') +
        item.title + variant +
        ' | Qty: ' + item.quantity +
        ' | Unit: ' + money(item.unit_price, request.currency) +
        ' | Line: ' + money(item.line_total, request.currency)
      );
    });

    lines.push(
      '',
      'TOTALS',
      'Total value: ' + money(request.catalogue_total, request.currency),
      'Basic product discount: -' + money(request.basic_discount, request.currency),
      'Special coupon discount: -' + money(request.special_discount, request.currency),
      'Value after discount: ' + money(request.net_products, request.currency),
      'Shipping Cost: ' + money(request.shipping, request.currency),
      'VAT 14%: ' + money(request.vat, request.currency),
      'Total quotation value: ' + money(request.grand_total, request.currency),
      '',
      'Review quotation online: ' + request.return_url
    );

    return lines.join('\n');
  }

  function submitRfqEmail(request) {
    var form = qs('#NsQuoteEmailForm');
    if (!form || !request || !request.email) return Promise.resolve(false);

    var key = RFQ_EMAIL_PREFIX + request.quote_number;
    try {
      var state = sessionStorage.getItem(key);
      if (state === 'pending' || state === 'sent') return Promise.resolve(state === 'sent');
      sessionStorage.setItem(key, 'pending');
    } catch (error) {}

    var formData = new FormData(form);
    formData.set('contact[email]', request.email);
    formData.set('contact[name]', request.contact || request.company);
    formData.set('contact[phone]', request.phone || '');
    formData.set('contact[RFQ / Quotation number]', request.quote_number);
    formData.set('contact[Customer company]', request.company);
    formData.set('contact[Selected language]', request.language);
    formData.set('contact[Total quotation value]', money(request.grand_total, request.currency));
    formData.set('contact[body]', quoteEmailBody(request));

    return fetch(form.action || rootUrl('contact'), {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      keepalive: true,
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('rfq-email');
      try { sessionStorage.setItem(key, 'sent'); } catch (error) {}
      return true;
    }).catch(function (error) {
      try { sessionStorage.removeItem(key); } catch (storageError) {}
      console.warn('Noor RFQ email could not be submitted.', error);
      return false;
    });
  }

  function recordQuotationRequest() {
    var request = runtime.currentRequest;
    if (!request || !request.quote_number) return;
    publishRfqEvent(request);
    submitRfqEmail(request);
  }

  function buildDocument(modal, data) {
    if (!validateModal(modal, data)) return;
    if (!runtime.shipping) { requestShipping(modal, data).then(function (rate) { if (rate) buildDocument(modal, data); }); return; }
    saveFields(modal, data);
    var fields = getFields(modal); var mode = fields.print_language || 'english'; var totals = calculateTotals(data); var issued = new Date(); var expires = new Date(issued.getTime()); expires.setDate(expires.getDate() + VALIDITY_DAYS);
    var quoteNumber = makeQuoteNumber(issued); var snapshot = snapshotForQuote(data, quoteNumber, issued, expires, totals); var returnUrl = buildReturnUrl(data, snapshot); var documents = '';
    if (mode === 'english' || mode === 'bilingual') documents += buildLanguageDocument('english', data, fields, totals, issued, expires, quoteNumber, returnUrl);
    if (mode === 'arabic' || mode === 'bilingual') documents += buildLanguageDocument('arabic', data, fields, totals, issued, expires, quoteNumber, returnUrl);
    var host = qs('[data-ns-quote-document]'); var printEl = qs('[data-ns-quote-print]'); if (!host || !printEl) return;
    host.innerHTML = documents; printEl.hidden = false; closeModal(); document.body.classList.add('ns-quote-open');
    runtime.currentQuoteNumber = quoteNumber; runtime.currentShareUrl = returnUrl; runtime.currentPrintMode = mode;
    runtime.currentPrintFilename = quoteNumber + '-' + safeFilenamePart(fields.company) + '-' + printModeSuffix(mode);
    runtime.currentRequest = buildRfqRequest(data, fields, totals, issued, expires, quoteNumber, returnUrl, mode);
    runtime.filenames = { english: quoteNumber + '-' + safeFilenamePart(fields.company) + '-EN', arabic: quoteNumber + '-' + safeFilenamePart(fields.company) + '-AR', bilingual: quoteNumber + '-' + safeFilenamePart(fields.company) + '-Bilingual' };

    // Set the title as soon as the preview opens. Mobile print/PDF dialogs often use the active page title as the suggested filename.
    document.title = runtime.currentPrintFilename;
  }

  function closePrint() {
    var printEl = qs('[data-ns-quote-print]'); if (printEl) printEl.hidden = true;
    document.body.removeAttribute('data-ns-quote-print-language'); document.title = runtime.originalTitle; document.body.classList.remove('ns-quote-open');

    // Return to the completed quotation form without clearing or reloading its saved fields.
    var modal = qs('[data-ns-quote-modal]'); var data = runtime.data || parseData();
    if (!modal || !data) return;
    loadSavedFields(modal, data); applyPopupPresentation(modal, data); renderFacility(modal, data); modal.hidden = false; document.body.classList.add('ns-quote-open'); renderSummary(modal, data);
    if (!runtime.shipping) requestShipping(modal, data);
    var first = qs('input:not([readonly]), select, textarea, button', modal); if (first) first.focus({ preventScroll: true });
  }

  function printCurrentQuotation() {
    if (!runtime.currentQuoteNumber || !qs('.ns-quote-document-set')) return;
    var mode = runtime.currentPrintMode || 'english';
    document.body.setAttribute('data-ns-quote-print-language', mode);
    document.title = runtime.currentPrintFilename || runtime.filenames[mode] || runtime.currentQuoteNumber || 'Noor-Quotation';

    // Count and email only when the customer actually presses Print, once per quotation number.
    recordQuotationRequest();

    // A short delay gives mobile browsers time to adopt the quotation title before opening the print/PDF dialog.
    window.setTimeout(function () { window.print(); }, 120);
  }

  function snapshotLinesMatch(snapshot, data) {
    var lines = snapshot && Array.isArray(snapshot.l) ? snapshot.l : []; var items = (data && data.items) || [];
    if (items.length !== lines.length) return false;
    var current = {}; items.forEach(function (item) { current[String(item.variant_id)] = item; });
    for (var i = 0; i < lines.length; i += 1) { var item = current[String(lines[i][0])]; if (!item || Number(item.quantity) !== Number(lines[i][1])) return false; }
    return true;
  }

  function compareSnapshot(snapshot, data) {
  if (!snapshot) {
    return {
      valid: true,
      reason: ''
    };
  }

  if (
    snapshot.c &&
    data.customer_id &&
    String(snapshot.c) !== String(data.customer_id)
  ) {
    return {
      valid: false,
      reason: 'owner',
      needsLoad: false
    };
  }

  var expired = false;

  if (snapshot.e) {
    var expiry = new Date(snapshot.e + 'T23:59:59');

    expired =
      !isNaN(expiry.getTime()) &&
      new Date() > expiry;
  }

  if (!snapshotLinesMatch(snapshot, data)) {
    return {
      valid: false,
      reason: expired ? 'expired' : 'missing',
      needsLoad: !expired
    };
  }

  var current = {};

  (data.items || []).forEach(function (item) {
    current[String(item.variant_id)] = item;
  });

  for (var i = 0; i < snapshot.l.length; i += 1) {
    var line = snapshot.l[i];
    var item = current[String(line[0])];

    if (
      !item ||
      Number(item.selling_unit_price) !== Number(line[2]) ||
      Number(item.reference_unit_price) !== Number(line[3]) ||
      stockProblems({ items: [item] }).length
    ) {
      return {
        valid: false,
        reason: 'changed',
        needsLoad: false
      };
    }
  }

  if (expired) {
    return {
      valid: false,
      reason: 'expired',
      needsLoad: false
    };
  }

  /*
   * Show the discount warning only when the quotation contained
   * a special discount and the currently applied discount amount
   * no longer matches it.
   *
   * Do not depend on sessionStorage validation because it can be
   * cleared even when Shopify still has the correct discount applied.
   */
  if (
    Number(snapshot.d || 0) > 0 &&
    Number(snapshot.d || 0) !== Number(data.special_discount || 0)
  ) {
    return {
      valid: false,
      reason: 'discount',
      needsLoad: false
    };
  }

  return {
    valid: true,
    reason: '',
    needsLoad: false
  };
}

  function buildReturnBanner(host, data, state, heading, message, type) {
    host.replaceChildren();
    var banner = document.createElement('section'); banner.className = 'ns-quote-return-banner ns-quote-return-banner--' + type;
    var content = document.createElement('div'); content.className = 'ns-quote-return-banner__content';
    var title = document.createElement('h2'); title.textContent = heading; var text = document.createElement('p'); text.textContent = message; content.appendChild(title); content.appendChild(text); banner.appendChild(content);
    if (state.needsLoad) { var button = document.createElement('button'); button.type = 'button'; button.className = 'button button--secondary ns-quote-load-button'; button.setAttribute('data-ns-quote-load', ''); button.textContent = t(data, 'load_quote_button', 'Load Quotation'); banner.appendChild(button); }
    var dismiss = document.createElement('button'); dismiss.type = 'button'; dismiss.className = 'ns-quote-return-banner__dismiss'; dismiss.setAttribute('data-ns-quote-dismiss-banner', ''); dismiss.setAttribute('aria-label', 'Dismiss'); dismiss.textContent = '×'; banner.appendChild(dismiss);
    host.appendChild(banner);
  }

  function showReturnState(data) {
    var snapshot = runtime.returnSnapshot || parseSnapshot(); if (!snapshot || !data) return; runtime.returnSnapshot = snapshot;
    var state = compareSnapshot(snapshot, data); var heading = t(data, 'quote_ready_title', 'Quotation link opened'); var message = t(data, 'quote_valid', 'The quoted items are loaded. Review current prices and availability before checkout.'); var type = 'success';
    if (state.valid) {
      try {
        if (sessionStorage.getItem('ns_quote_just_loaded_v7') === '1') {
          sessionStorage.removeItem('ns_quote_just_loaded_v7');
          heading = t(data, 'quote_loaded_title', 'Quotation items loaded');
          message = t(data, 'quote_loaded', 'The quoted items were loaded. Review the cart before continuing.');
        }
      } catch (error) {}
    }
    if (!state.valid) {
      type = 'warning';
      if (state.reason === 'expired') { heading = t(data, 'quote_expired_title', 'Quotation expired'); message = t(data, 'quote_expired', 'This quotation has expired. Print a new quotation.'); }
      else if (state.reason === 'owner') { heading = t(data, 'quote_owner_title', 'Quotation unavailable'); message = t(data, 'quote_owner_mismatch', 'This quotation link is not associated with the logged-in account.'); }
      else if (state.reason === 'discount') { heading = t(data, 'quote_discount_title', 'Discount revalidation required'); message = t(data, 'quote_discount_required', 'Re-enter the special discount code to restore the quoted discount.'); }
      else if (state.reason === 'missing') { heading = t(data, 'load_quote_title', 'Load quotation') + (snapshot.q ? ' ' + snapshot.q : ''); message = t(data, 'load_quote_message', 'The quoted items are not currently loaded. Loading them will replace your current cart after confirmation.'); }
      else { heading = t(data, 'quote_changed_title', 'Quotation review required'); message = t(data, 'quote_changed', 'The current cart no longer matches this quotation.'); }
    }
    var host = qs('[data-ns-quote-return-host]'); if (host) buildReturnBanner(host, data, state, heading, message, type);
  }

  function loadQuotedCart() {
    var snapshot = runtime.returnSnapshot || parseSnapshot(); var data = runtime.data || parseData(); if (!snapshot || !data || !Array.isArray(snapshot.l) || !snapshot.l.length) return;
    if ((data.items || []).length && !window.confirm(t(data, 'load_quote_confirm', 'Loading this quotation will replace the products currently in your cart. Continue?'))) return;
    var button = qs('[data-ns-quote-load]'); if (button) button.disabled = true;
    var items = snapshot.l.map(function (line) { return { id: Number(line[0]), quantity: Number(line[1]) }; });
    var previousItems = (data.items || []).map(function (item) { return { id: Number(item.variant_id), quantity: Number(item.quantity) }; }); var previousCodes = discountCodeTitles(data.discount_applications || []);
    fetch(rootUrl('cart/clear.js'), { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('clear'); return response.json(); }).then(function () { return postDiscount(''); })
      .then(function () { return fetch(rootUrl('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function (response) { if (!response.ok) return response.json().catch(function () { return {}; }).then(function (body) { throw new Error(body.description || 'add'); }); return response.json(); })
      .then(function () { try { sessionStorage.setItem('ns_quote_just_loaded_v7', '1'); } catch (error) {} window.location.reload(); })
      .catch(function () {
        var restore = fetch(rootUrl('cart/clear.js'), { method: 'POST', headers: { Accept: 'application/json' } }).then(function () {
          if (!previousItems.length) return null;
          return fetch(rootUrl('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: previousItems }) });
        }).then(function () { return previousCodes.length ? postDiscount(previousCodes[0]) : null; }).catch(function () {});
        restore.finally(function () { if (button) button.disabled = false; var host = qs('[data-ns-quote-return-host]'); if (host) buildReturnBanner(host, data, { needsLoad: true }, t(data, 'quote_changed_title', 'Quotation review required'), t(data, 'load_quote_error', 'The quoted items could not be loaded. Refresh and try again.'), 'warning'); });
      });
  }

  function redirectGuestToLogin(data) {
    if (!data || data.customer_id || !data.login_url) return false;
    try { var login = new URL(data.login_url, window.location.origin); login.searchParams.set('return_to', window.location.pathname + window.location.search + window.location.hash); window.location.replace(login.toString()); return true; }
    catch (error) { return false; }
  }

  function quoteSnapshotCanRestoreDiscount(snapshot, data) {
    if (!snapshot || !data || !snapshot.dc || Number(snapshot.d || 0) <= 0) return false;

    if (
      snapshot.c &&
      String(snapshot.c) !== String(data.customer_id || '')
    ) return false;

    if (snapshot.e) {
      var expiry = new Date(snapshot.e + 'T23:59:59');
      if (!isNaN(expiry.getTime()) && new Date() > expiry) return false;
    }

    if (!snapshotLinesMatch(snapshot, data)) return false;

    var current = {};
    (data.items || []).forEach(function (item) {
      current[String(item.variant_id)] = item;
    });

    for (var i = 0; i < snapshot.l.length; i += 1) {
      var line = snapshot.l[i];
      var item = current[String(line[0])];

      if (
        !item ||
        Number(item.selling_unit_price) !== Number(line[2]) ||
        Number(item.reference_unit_price) !== Number(line[3]) ||
        stockProblems({ items: [item] }).length
      ) return false;
    }

    return true;
  }

  function restoreQuoteDiscount(snapshot, data) {
    if (!quoteSnapshotCanRestoreDiscount(snapshot, data)) {
      return Promise.resolve(data);
    }

    var code = cleanText(snapshot.dc || '');
    var appliedCodes = discountCodeTitles(
      data.discount_applications || []
    ).map(normalizeCode);

    if (appliedCodes.indexOf(normalizeCode(code)) !== -1) {
      rememberQuoteDiscount(code);
      return Promise.resolve(data);
    }

    var previousCodes = discountCodeTitles(data.discount_applications || []);

    return postDiscount(code)
      .then(function (cart) {
        var fresh = mergeLiveCart(data, cart);
        var restoredExactly =
          codeIsApplied(cart, code) &&
          Number(fresh.special_discount || 0) === Number(snapshot.d || 0);

        if (!restoredExactly) {
          return postDiscount(previousCodes.join(','))
            .catch(function () { return null; })
            .then(function () { return refreshData(data); });
        }

        rememberQuoteDiscount(code);

        // Reload once so Dawn's cart subtotal and discount badge update.
        window.location.reload();
        return null;
      })
      .catch(function () {
        return data;
      });
  }
  function initReturnState() {
    runtime.returnSnapshot = parseSnapshot();
    if (!runtime.returnSnapshot) return;

    var data = parseData();
    if (!data) return;
    if (redirectGuestToLogin(data)) return;

    refreshData(data)
      .then(function (fresh) {
        return restoreQuoteDiscount(runtime.returnSnapshot, fresh);
      })
      .then(function (fresh) {
        // A reload has already started after restoring the discount.
        if (!fresh) return;

        runtime.data = fresh;
        showReturnState(fresh);
      });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-ns-quote-load]')) { event.preventDefault(); loadQuotedCart(); return; }
    if (event.target.closest('[data-ns-quote-dismiss-banner]')) { event.preventDefault(); var host = qs('[data-ns-quote-return-host]'); if (host) host.replaceChildren(); return; }
    if (event.target.closest('[data-ns-quote-reset]')) { event.preventDefault(); resetAccountFields(); return; }
    if (event.target.closest('[data-ns-quote-open]')) { event.preventDefault(); openModal(); return; }
    if (event.target.closest('[data-ns-quote-close]')) { event.preventDefault(); closeModal(); return; }
    if (event.target.closest('[data-ns-quote-apply-code]')) { event.preventDefault(); applyDiscountCode(); return; }
    if (event.target.closest('[data-ns-quote-remove-code]')) { event.preventDefault(); removeDiscountCode(); return; }
    if (event.target.closest('[data-ns-quote-preview]')) { event.preventDefault(); var modal = qs('[data-ns-quote-modal]'); var data = runtime.data || parseData(); if (modal && data) buildDocument(modal, data); return; }
    if (event.target.closest('[data-ns-quote-close-print]')) { event.preventDefault(); closePrint(); return; }
    var printButton = event.target.closest('[data-ns-quote-print-action]'); if (printButton) { event.preventDefault(); printCurrentQuotation(); return; }
  });

  document.addEventListener('change', function (event) {
    var modal = qs('[data-ns-quote-modal]'); var data = runtime.data || parseData();
    if (event.target.matches('[data-ns-quote-same-address]')) { if (modal) { applySameAddressState(modal, event.target.checked); runtime.shipping = null; renderSummary(modal, data); requestShipping(modal, data); } return; }
    if (!event.target.matches('[data-ns-quote-field="billing_governorate"], [data-ns-quote-field="billing_city"], [data-ns-quote-field="billing_zip"], [data-ns-quote-field="delivery_governorate"], [data-ns-quote-field="delivery_city"], [data-ns-quote-field="delivery_zip"]')) return;
    if (modal && data) requestShipping(modal, data);
  });

  document.addEventListener('input', function (event) {
    if (event.target.id !== 'NsQuoteDiscountCode') return;
    event.target.removeAttribute('aria-invalid'); var status = qs('[data-ns-quote-discount-status]');
    if (status) {
      var discountText = discountStatus(runtime.data || parseData());
      status.dataset.messageLock = '';
      status.className = 'ns-quote-current-discounts';
      status.textContent = discountText;
      status.hidden = !discountText;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { if (qs('[data-ns-quote-print]:not([hidden])')) closePrint(); else closeModal(); return; }
    if (event.key !== 'Tab') return;
    var layer = qs('[data-ns-quote-print]:not([hidden])') || qs('[data-ns-quote-modal]:not([hidden])'); if (!layer) return;
    var focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', layer).filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return; var first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); } else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  window.addEventListener('afterprint', function () { document.body.removeAttribute('data-ns-quote-print-language'); if (runtime.currentPrintFilename) document.title = runtime.currentPrintFilename; });

  document.addEventListener('DOMContentLoaded', function () {
    mountOverlays(); ensurePopupPresentationStyles(); initReturnState();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () {
        var base = parseData(); if (!base) return; refreshData(base).then(function (fresh) { runtime.data = fresh; if (runtime.returnSnapshot) showReturnState(fresh); var modal = qs('[data-ns-quote-modal]:not([hidden])'); if (modal) { runtime.shipping = null; renderSummary(modal, fresh); requestShipping(modal, fresh); } });
      }, 100); });
    }
    var reopen = false; try { reopen = sessionStorage.getItem(DISCOUNT_REOPEN_KEY) === '1'; if (reopen) sessionStorage.removeItem(DISCOUNT_REOPEN_KEY); } catch (error) {}

    // A discount entered inside Print Quotation must not remain on an
    // ordinary cart. Skip this cleanup only during the intentional reload
    // that immediately reopens the quotation modal.
    if (!runtime.returnSnapshot && !reopen) removeQuoteDiscountFromNormalCart();
    if (reopen && qs('[data-ns-quote-open]')) setTimeout(openModal, 250);
    if (window.location.hash === '#ns-print-quotation' && qs('[data-ns-quote-open]')) setTimeout(openModal, 250);
  });
})();
